import { Box, Checkbox, Divider, Grid, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import TextFieldLabel from "../common/TextFieldLabel";
import { CustomSelectBox } from "assets/styles/globalStyledComponent";
import { MenuProps } from "app/utils/helper";
import ClassDropDown from "app/modules/fee-management/fee-structure/ClassDropdown";
import { useClassData } from "app/hooks/globallyApplicable/useClassData";
import { useFormik } from "formik";

const ByClassFilter = ({ prevClassList, setSelectedClasses }) => {
  const [classList, setClassList] = useState([]);
  const [classListVersion, setClassListVersion] = useState(0);

  const formik = useFormik({
    initialValues: {
      postClassList: Array.isArray(prevClassList) ? prevClassList : [],
    },
    onSubmit: (values) => {},
  });

  const { classList: classListData, error } = useClassData();

  useEffect(() => {
    if (classListData && classListData.length > 0) {
      if (formik.values.postClassList.length > 0) {
        const transformedList = classListData.map((classItem) => {
          const body = {
            classDocId: classItem?.classDocId,
            className: classItem?.className_stream,
            queryClassName: classItem?.className,
            sections: [],
            checked: false,
          };
          const updatedSections = classItem?.sections?.map((section) => {
            const isChecked = formik?.values?.postClassList.some(
              (postClass) =>
                postClass?.classDocId === classItem?.classDocId &&
                postClass?.section === section,
            );
            return {
              section,
              checked: isChecked,
            };
          });
          body.sections = updatedSections;
          body.checked = updatedSections.every((section) => section.checked);
          return body;
        });

        setClassList(transformedList);
        setClassListVersion((v) => v + 1);
      } else {
        const arr = [];
        classListData.forEach((item) => {
          const body = {
            classDocId: item?.classDocId,
            className: item?.className_stream,
            queryClassName: item?.className,
            sections: [],
            checked: false,
          };
          item?.sections?.forEach((res) => {
            body?.sections?.push({
              section: res,
              checked: false,
            });
          });
          arr.push(body);
        });

        setClassList(arr);
        setClassListVersion((v) => v + 1);
      }
    }
  }, [classListData, formik.values.postClassList]);

  // Handle class data error
  useEffect(() => {
    if (error) {
      console.error("Failed to fetch class data:", error);
    }
  }, [error]);

  useEffect(() => {
    setSelectedClasses(formik.values.postClassList);
  }, [formik.values.postClassList, setSelectedClasses]);

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <TextFieldLabel title={"Class-Stream-Sec"} />
          <CustomSelectBox
            size="small"
            fullWidth
            multiple
            displayEmpty
            MenuProps={MenuProps}
            value={formik.values.postClassList ?? []}
            error={
              formik.touched.postClassList &&
              Boolean(formik.errors.postClassList)
            }
            renderValue={(selected) => {
              if (Array.isArray(selected) && selected.length > 0) {
                return (
                  <span>
                    {(selected ?? []).map((cls) => cls?.display).join(", ")}
                  </span>
                );
              }
              return <Typography sx={{ opacity: 0.8 }}>Select</Typography>;
            }}
          >
            <Box sx={{ px: 1, py: 0.5 }}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Stack direction="row" alignItems="center" gap={1}>
                  <Checkbox
                    color="secondary"
                    checked={
                      Array.isArray(classListData) &&
                      classListData.length > 0 &&
                      (formik.values?.postClassList?.length ?? 0) > 0 &&
                      (formik.values?.postClassList?.length ?? 0) ===
                        (classListData ?? []).reduce(
                          (sum, c) => sum + (c?.sections?.length ?? 0),
                          0,
                        )
                    }
                    onChange={(e) => {
                      const shouldSelectAll = e.target.checked;
                      if (!shouldSelectAll) {
                        formik.setValues((prev) => ({
                          ...prev,
                          postClassList: [],
                        }));
                        return;
                      }
                      const all = [];
                      (classListData ?? []).forEach((c) => {
                        (c?.sections ?? []).forEach((section) => {
                          all.push({
                            classDocId: c?.classDocId,
                            section,
                            display: `${c?.className_stream}-${section}`,
                            queryClass: c?.className,
                          });
                        });
                      });
                      formik.setValues((prev) => ({
                        ...prev,
                        postClassList: all,
                      }));
                    }}
                  />
                  <Typography sx={{ fontWeight: 600 }}>All</Typography>
                </Stack>
                <Typography sx={{ fontSize: 12, opacity: 0.7 }}>
                  {formik.values?.postClassList?.length ?? 0} selected
                </Typography>
              </Stack>
            </Box>
            <Divider sx={{ background: "#B6C8D6" }} />
            {classList?.map((item, ind) => (
              <ClassDropDown
                item={item}
                index={ind}
                formikSetState={formik.setValues}
                formikState={formik.values}
                key={`${item?.classDocId ?? ind}-${classListVersion}`}
              />
            ))}
          </CustomSelectBox>
          {formik.touched.postClassList &&
            Boolean(formik.errors.postClassList) && (
              <Typography color="error">
                {formik.errors.postClassList}
              </Typography>
            )}
        </Grid>
      </Grid>
    </>
  );
};

export default ByClassFilter;
